import { Link } from '@sainsburys-tech/fable';
import * as React from 'react';
export default {
  Link,
  React
};